
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UIButton',
  props: {
    name: {
      type: String,
      required: true,
    },
    modifier: {
      type: String,
      default: 'primary',
    },
  },
})
